import group from './group'
import level from './level'

export default {
  name: 'BaseInfoUser',
  path: 'user',
  meta: {
    label: 'users',
    auth: 'user'
  },
  component: {
    name: 'User',
    render(c) {
      return c('router-view')
    }
  },
  children: [group, level]
}
